import type { ButtonTrackingProps } from '@components/button/props'
import * as ICONS from '@components/icons/mobile-store'
import { useStores } from '@lib/store/useStores'
import { LINK } from '@shared/util/link'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './app-button.module.scss'

/** Android/iOS app store button */
export const AppButton: FunctionComponent<React.PropsWithChildren<Props>> = ({
    type,
    color,
    containerElementId,
    ...restOfProps
}) => {
    const Icon = ICONS[type]
    const href = LINK.app[type]()
    const {
        deviceStore: { os },
    } = useStores()

    if (!href) return null

    const name = type.toLowerCase()

    return (
        <a
            href={href}
            target='_blank'
            rel='noopener noreferrer'
            className={classNames(
                styles.button,
                styles[name],
                os && styles[`${name}-on-${os.toLowerCase()}`],
            )}
            {...restOfProps}
        >
            <Icon height='100%' color={color} />
        </a>
    )
}

interface Props extends Partial<ButtonTrackingProps> {
    type: 'AppStore' | 'GooglePlay'
    color?: 'step-white' | 'step-midnight'
}
